import { ResultState, Result, HeaderInfo, CheckType, ResultTabType } from './state'

export const getResult = function (state: ResultState): Result {
  return state.result
}

export const getHeaderInfo = function (state: ResultState): HeaderInfo | null {
  return state.headerInfo
}

export const getChecksCounter = function (state: ResultState): number {
  return state.checksCounter
}

export const getCheckType = function (state: ResultState): CheckType {
  return state.checkType
}

export const getResultTabType = function (state: ResultState): ResultTabType {
  return state.resultTabType
}

export const getChecksCounterUpdated = function (state: ResultState): boolean {
  return state.checksCounterUpdated
}
